module.exports = __webpack_public_path__ + "img/wxcode.3c4dfe95.jpg";